export default {
    page_title: "Kevi | Forms",
    manage_title: "Manage Forms",
    new_btn: "New Form",
    max_reached: "You have reached the maximum of {0} forms",
    modal_rename_title: "Rename Form",
    modal_add_title: "Add Form",
    name_label: "Name:",
    btn_add: "Add",
    btn_save: "Save",
    confirm_delete_question: "Are you sure you want to delete the Form",
    confirm_delete_body: "After deletion, the action will be irreversible.",
    confirm_duplicate_question: "Are you sure you want to duplicate the Form",
    confirm_duplicate_body: "After duplication, the form will be created with the same name.",
    answers: "answers",
    tooltip_manage: "Manage Questions",
    tooltip_view: "View Form",
    tooltip_view_tab: "View Form in new tab",
    tooltip_report: "Answers Report",
    tooltip_export: "Export Answers",
    tooltip_duplicate: "Duplicate Form",
    tooltip_rename: "Rename Form",
    tooltip_remove: "Remove Form",
    notification_duplicated: "Form duplicated successfully!",
    notification_deleted: "Form deleted successfully.",
    notification_saved: "Form saved successfully.",
    notification_reset: "Form reset successfully.",
    btn_cancel: "Cancel",
    count_forms: "{0} forms",
    search_placeholder: "Search form",
    questions_count: "{0} questions",
    answers_count: "{0} answers",
    action_questions: "Questions",
    action_answers: "Answers",
    action_copy_link: "Copy public link",
    link_copied: "Link copied to the clipboard.",
    more_actions: "More actions",
    empty_title: "No forms yet",
    empty_subtitle: "Create your first form to start collecting answers.",
    empty_search: "No form matches this search.",
    settings: {
        title: "Customer details",
        subtitle: "Choose which details the form asks for before submitting the answers.",
        field_askName: "First name",
        field_askLastName: "Last name",
        field_askEmail: "Email",
        field_askPhone: "Phone",
        field_askBirthdate: "Date of birth",
        ask_no: "Don't ask",
        ask_optional: "Optional",
        ask_required: "Required",
        btn_save: "Save details",
        notification_saved: "Form settings saved.",
    },
    appearance: {
        tooltip: "Form settings",
        title: "Form settings",
        subtitle: "Choose where client details appear and the success message.",
        position_label: "Client fields position",
        position_below: "Below questions",
        position_above: "Above questions",
        success_title_label: "Success title",
        success_title_placeholder: "Thank you!",
        success_message_label: "Success message",
        success_message_placeholder: "Your opinion is very important!",
        btn_save: "Save settings",
        notification_saved: "Form settings saved.",
    },
    questions: {
        title: "Form",
        list_title: "Questions",
        count: "{0} questions",
        answers_count: "{0} answers",
        empty_title: "No questions yet",
        empty_subtitle: "Add the first question to build your form.",
        open_public: "Open form",
        btn_back: "Back",
        btn_add_question: "Add Question",
        pending_changes: "You have pending changes.",
        leave_unsaved: "You have unsaved changes. If you leave now, they will be lost. Do you want to continue?",
        revert_changes: "Revert changes",
        btn_save: "Save",
        conditional: "Conditional question",
        answers: "answers",
        new_question: "New question",
        will_remove: "This question will be removed when saving",
        view_answers: "View Answers",
        tooltip_condition: "Add Condition",
        tooltip_delete: "Delete question",
        copy_id: "Copy question ID",
        id_copied: "Question ID copied",
        tooltip_edit: "Edit question",
        tooltip_undo: "Undo removal",
        type_emotion: "Emotional scale (CSAT)",
        type_comment: "Open answer",
        type_boolean: "Yes or no",
        type_selectbox: "Multiple Choice",
        type_input: "Short text",
        type_nps: "NPS Metric",
        type_date: "Date",
        type_ces: "CES Metric",
        type_file: "File",
        type_content: "Explanatory text",
        type_emotion_hint: "Score from 1 to 5 with faces.",
        type_comment_hint: "Open field for longer text.",
        type_boolean_hint: "Binary yes or no answer.",
        type_selectbox_hint: "List of options to pick from.",
        type_input_hint: "Single line text field.",
        type_nps_hint: "Recommendation score from 0 to 10.",
        type_date_hint: "Pick a date on the calendar.",
        type_ces_hint: "Effort score from 1 to 7.",
        type_file_hint: "Upload images and documents.",
        type_content_hint: "Formatted text block, no answer.",
    },
    report: {
        page_title: "Kevi | Answers Report",
        title: "Answers Report",
        btn_export: "Export",
        no_answers_found: "No answers found",
        no_answers_description: "Have you started sharing your new loyalty program? Don't receive tomorrow the feedback you can receive today.",
        segment_filter: "Client segment",
    },
    questions_form: {
        close: "Close",
        select_type_title: "Select the question type",
        back: "Back",
        fill_data_title: "Fill in the question details",
        edit_title: "Edit question",
        type_locked: "(cannot be changed)",
        remove_option: "Remove option",
        undo_remove_option: "Undo option removal",
        content_label: "Content shown in the form",
        content_hint: "Select the text to format it with headings, bold, italic and lists.",
        placeholder_content: "Tell customers what they need to know before answering.",
        error_content: "Write the content that will be shown in the form",
        impact_hint: "This question already has {0} answers. Changing its text or options changes how they show up in reports.",
        impact_title: "This change affects past reports",
        impact_body: "This question has already been answered {0} times.",
        impact_body_extra: "Existing answers will be shown with the new text and options across every report and export.",
        impact_confirm: "Change anyway",
        type_label: "Type:",
        question_text_label: "Your question text:",
        multiselect_label: "Multiple selection",
        multiselect_hint: "Allows multiple selection among the proposed options.",
        options_label: "Options:",
        option_will_remove: "This option will be removed when saving",
        btn_add_option: "New Option",
        btn_save_question: "Save Question",
        btn_add_question: "Add Question",
        error_question: "Please specify the question text correctly",
        error_options: "Please specify at least two options for the list, and fill in all of them correctly with a minimum of two characters.",
        placeholder_default: "How was the food?",
        placeholder_selectbox: "How did you hear about our services?",
        placeholder_date: "Day you visited us",
        placeholder_file: "Upload your artwork or company logo",
        placeholder_option: "Option {0}",
        file_multiple_label: "Allow multiple files",
        file_multiple_hint: "Lets the customer upload more than one file for this question.",
        file_max_files_label: "Maximum files:",
        file_types_label: "Accepted file types:",
        file_types_any: "Any file type allowed by Kevi",
        file_types_image: "Images only",
        file_types_image_dst: "Images or embroidery (.DST)",
        file_types_dst: "Embroidery only (.DST)",
        file_formats_hint: "The global limit is 30 MB per file.",
    },
    report_component: {
        answers: "answers",
        general_assessment: "General Assessment",
        no_answers: "No one has answered this question yet.",
        see_all_answers: "See all answers",
        grade_very_good: "Very good",
        grade_good: "Good",
        grade_neutral: "Neutral",
        grade_bad: "Bad",
        grade_very_bad: "Very bad",
        boolean_yes: "Yes",
        boolean_no: "No",
        nps_promoter: "Promoter",
        nps_neutral: "Neutral",
        nps_detractor: "Detractor",
        ces_label_1: "Extremely difficult",
        ces_label_2: "Very difficult",
        ces_label_3: "Difficult",
        ces_label_4: "Acceptable",
        ces_label_5: "Easy",
        ces_label_6: "Very easy",
        ces_label_7: "Extremely easy",
        selectbox_view: "View",
        selectbox_list: "List",
        selectbox_chart: "Chart",
    },
    conditions: {
        modal_title: "Visibility conditions",
        header_text: "Use conditions to create dynamic and personalized forms, allowing you to control the visibility of questions based on responses provided in previous questions (therefore, the first question cannot have conditions).",
        no_previous_warning: "The first question cannot have conditions, as there are no previous questions to base the condition on.",
        btn_cancel: "Cancel",
        btn_confirm: "Confirm",
        error_fill_all: "Please fill in all condition fields before saving.",
        operator_label: "Operator:",
        operator_and: "AND (all conditions)",
        operator_or: "OR (any condition)",
        btn_add_condition: "Add Condition",
        btn_add_group: "Add Group",
        remove_condition: "Remove condition",
        remove_group: "Remove group",
        empty_message: "Add conditions or groups to build your logic",
        condition_label: "Condition",
        question_label: "Question",
        select_placeholder: "Select...",
        operator_select_label: "Operator",
        value_label: "Value",
        value_placeholder: "Enter value",
        emotion_1: "1 - Very Dissatisfied",
        emotion_2: "2 - Dissatisfied",
        emotion_3: "3 - Neutral",
        emotion_4: "4 - Satisfied",
        emotion_5: "5 - Very Satisfied",
        boolean_yes: "Yes",
        boolean_no: "No",
        op_equal: "Equal to",
        op_not_equal: "Not equal to",
        op_greater_than: "Greater than",
        op_greater_than_or_equal: "Greater than or equal to",
        op_less_than: "Less than",
        op_less_than_or_equal: "Less than or equal to",
        op_includes: "Contains",
        op_answered: "Answered",
    },
    embed: {
        title: "Use this form on my website",
        subtitle: "Copy the code to show the form on your page or send answers from your own form.",
        tab_link: "Direct link",
        tab_iframe: "Via iframe",
        tab_js: "Code integration",
        copy: "Copy",
        copied: "Copied",
        copied_toast: "Code copied",
        link_help: "Use this link to open the form on its own page, WhatsApp, email, or any other channel.",
        iframe_lead: "Low-tech and works fast — best for putting the Kevi form on your site with little customization.",
        sdk_step: "1. Install the Kevi SDK",
        sdk_help: "Add this code in Google Tag Manager or in your site's <head>. It resizes the iframe and notifies you when the form is submitted.",
        sdk_snippet_label: "Kevi SDK",
        iframe_step: "2. Paste the iframe on the page",
        iframe_help: "After the SDK, paste this code in the HTML where the form should appear.",
        iframe_snippet_label: "Iframe code",
        js_lead: "Full customization: plug Kevi into a 100% custom form on your site, with your UI and your rules.",
        js_help: "Send answers from your form to Kevi with this code. The IDs below belong to this form.",
        js_snippet_label: "JavaScript code",
        js_note_omit: "Omit from the payload any questions the visitor did not answer.",
        js_note_validate: "Required-field validation lives on your site — the API accepts partial submissions.",
        js_note_response: "On success the API returns answer, coupon and client. If you use the SDK, you can pass client to kevi.setClient().",
        questions_title: "Questions and IDs",
        questions_help: "Use these IDs as keys in steps_questions. Click an ID to copy it.",
        questions_empty: "Save the form with at least one question to generate code with IDs.",
        format_emotion: "Number from 1 to 5",
        format_nps: "Number from 0 to 10",
        format_ces: "Number from 1 to 7",
        format_boolean: "\"1\" (yes) or \"0\" (no)",
        format_selectbox: "Array with the option texts",
        format_input: "Text",
        format_comment: "Text",
        format_date: "Date in YYYY-MM-DD format",
        format_file: "Array of files {url, name, type, size} after POST /form/{id}/upload",
    },
};
